import { useState, createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import css from './DropdownWrapper.module.css'

const DropdownReferenceContext = createContext<HTMLDivElement | null>(null)

export const useDropdownReference = () => useContext(DropdownReferenceContext)

interface DropdownWrapperProps {
    children: ReactNode
}

const DropdownWrapper = ({ children }: DropdownWrapperProps) => {
    const [referenceEl, setReferenceEl] = useState<HTMLDivElement | null>(null)

    return (
        <DropdownReferenceContext.Provider value={referenceEl}>
            <div ref={setReferenceEl} className={css.wrapper}>
                {children}
            </div>
        </DropdownReferenceContext.Provider>
    )
}

export default DropdownWrapper
